import { DisplayPosition } from '@/type/display-position';
import isPlainObject from 'lodash/isPlainObject';
export default {
    position: [DisplayPosition.filter],
    title: '搜索',
    componentName: 'CnSearch',
    getFormItemDefaultProps: () => {
        return {};
    },
    getPrototypeList: () => {
        return [];
    },
    formItemBeforeHandler: (formItem, config) => {
        const { formInstance } = config;
        const componentProps = formItem['x-component-props'];
        if (isPlainObject(componentProps)) {
            componentProps.onSearch = () => {
                formInstance?.filterSearch?.();
            };
            componentProps.showSearchButton = true;
        }
    },
};
